document.addEventListener('DOMContentLoaded', function() {
  const MAX_ITEMS = 6;
  let selectedItems = []; // Array of { id, title, image, handle }

  // DOM Elements
  const builderContainer = document.getElementById('SeoulBuilder');
  if (!builderContainer) return;

  const slots = document.querySelectorAll('.capsule-slot');
  const trackerText = document.getElementById('BuilderTrackerText');
  const footerCta = document.getElementById('BuilderFooterCta');
  const cards = document.querySelectorAll('.seoul-builder-card');
  const drawer = document.getElementById('PdpQuickviewDrawer');
  const drawerOverlay = document.getElementById('DrawerOverlay');
  const drawerCloseBtn = document.getElementById('DrawerCloseBtn');

  // Quickview Inner Elements
  const drawerMediaFrame = document.getElementById('DrawerMediaFrame');
  const drawerProductTitle = document.getElementById('DrawerProductTitle');
  const drawerProductPrice = document.getElementById('DrawerProductPrice');
  const drawerProductNarrative = document.getElementById('DrawerProductNarrative');
  const drawerSpecsList = document.getElementById('DrawerSpecsList');
  const drawerAddBtn = document.getElementById('DrawerAddBtn');

  // Initialize click handlers for grid cards
  cards.forEach(card => {
    const media = card.querySelector('.seoul-builder-card-media');
    const title = card.querySelector('.seoul-builder-card-title');
    const selectBtn = card.querySelector('.card-select-btn');

    // Add to capsule directly via plus button
    if (selectBtn) {
      selectBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        toggleItemSelection(card);
      });
    }

    // Open Quickview Mini PDP when clicking media or title
    const openQuickview = function() {
      const productJsonStr = card.querySelector('.product-json').textContent;
      const productData = JSON.parse(productJsonStr);
      showQuickView(productData, card);
    };

    if (media) media.addEventListener('click', openQuickview);
    if (title) title.addEventListener('click', openQuickview);
  });

  // Toggle selection
  function toggleItemSelection(card) {
    const variantId = card.getAttribute('data-variant-id');
    const title = card.querySelector('.seoul-builder-card-title').textContent.trim();
    const image = card.getAttribute('data-featured-image');
    const handle = card.getAttribute('data-product-handle');

    const index = selectedItems.findIndex(item => item.id === variantId);

    if (index > -1) {
      // Remove item
      selectedItems.splice(index, 1);
      card.classList.remove('is-selected');
    } else {
      // Add item if within limit
      if (selectedItems.length >= MAX_ITEMS) {
        alert('Your Seoul Capsule is full! Remove an item to add a new one.');
        return;
      }
      selectedItems.push({ id: variantId, title, image, handle });
      card.classList.add('is-selected');
    }

    updateUI();
  }

  // Update slots, tracker text, and CTAs
  function updateUI() {
    // 1. Update Sticky Slots in Header
    slots.forEach((slot, i) => {
      const slotRemoveBtn = slot.querySelector('.slot-remove-btn');
      
      if (selectedItems[i]) {
        // Fill slot
        slot.classList.add('is-filled');
        let img = slot.querySelector('img');
        if (!img) {
          img = document.createElement('img');
          slot.appendChild(img);
        }
        img.src = selectedItems[i].image;
        img.alt = selectedItems[i].title;
        slot.setAttribute('data-slot-variant-id', selectedItems[i].id);

        if (slotRemoveBtn) {
          slotRemoveBtn.style.display = 'flex';
          // Click handler to remove
          slotRemoveBtn.onclick = function(e) {
            e.stopPropagation();
            removeItemById(selectedItems[i].id);
          };
        }
      } else {
        // Reset empty slot
        slot.classList.remove('is-filled');
        const img = slot.querySelector('img');
        if (img) img.remove();
        slot.removeAttribute('data-slot-variant-id');
        if (slotRemoveBtn) slotRemoveBtn.style.display = 'none';
      }
    });

    // 2. Update status tracker banner text
    const itemsNeeded = MAX_ITEMS - selectedItems.length;
    if (itemsNeeded > 0) {
      trackerText.textContent = `complete your seoul capsule: select ${itemsNeeded} more pair${itemsNeeded > 1 ? 's' : ''}`;
      footerCta.disabled = true;
      footerCta.textContent = `ADD ${itemsNeeded} MORE (₹1,199)`;
    } else {
      trackerText.textContent = `Capsule complete! Claim your set below.`;
      footerCta.disabled = false;
      footerCta.textContent = `CLAIM YOUR CAPSULE — ₹1,199`;
    }

    // 3. Keep Grid Card Selection states in sync
    cards.forEach(card => {
      const variantId = card.getAttribute('data-variant-id');
      const isSelected = selectedItems.some(item => item.id === variantId);
      if (isSelected) {
        card.classList.add('is-selected');
      } else {
        card.classList.remove('is-selected');
      }
    });

    // 4. Update Quick-View add button state if drawer is open
    if (drawer.classList.contains('is-open')) {
      const currentDrawerVariantId = drawerAddBtn.getAttribute('data-variant-id');
      const isSelectedInDrawer = selectedItems.some(item => item.id === currentDrawerVariantId);
      if (isSelectedInDrawer) {
        drawerAddBtn.textContent = 'REMOVE FROM CAPSULE';
        drawerAddBtn.style.backgroundColor = 'var(--color-gold)';
      } else {
        drawerAddBtn.textContent = 'ADD TO CAPSULE';
        drawerAddBtn.style.backgroundColor = 'var(--color-charcoal)';
      }
    }
  }

  // Helper to remove item directly by ID
  function removeItemById(id) {
    const index = selectedItems.findIndex(item => item.id === id);
    if (index > -1) {
      selectedItems.splice(index, 1);
      updateUI();
    }
  }

  // Quickview Display Logic
  function showQuickView(product, cardElement) {
    drawerProductTitle.textContent = product.title.toLowerCase();
    drawerProductPrice.textContent = product.price;
    drawerProductNarrative.textContent = product.narrative || "";

    // Render Media (Prefer Video, fallback to image)
    drawerMediaFrame.innerHTML = '';
    if (product.video_url) {
      const video = document.createElement('video');
      video.src = product.video_url;
      video.autoplay = true;
      video.loop = true;
      video.muted = true;
      video.playsInline = true;
      
      const playOverlay = document.createElement('div');
      playOverlay.className = 'video-play-overlay';
      playOverlay.innerHTML = '<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>';

      drawerMediaFrame.appendChild(video);
      drawerMediaFrame.appendChild(playOverlay);
    } else {
      const img = document.createElement('img');
      img.src = cardElement.getAttribute('data-featured-image');
      img.alt = product.title;
      drawerMediaFrame.appendChild(img);
    }

    // Render Specs List
    drawerSpecsList.innerHTML = '';
    const specs = product.specs || [
      "316L Surgical Stainless Steel Base",
      "18K Gold PVD Plating (Anti-Tarnish)",
      "100% Waterproof & Sweatproof",
      "Nickel-free & Hypoallergenic"
    ];
    specs.forEach(spec => {
      const li = document.createElement('li');
      li.textContent = spec;
      drawerSpecsList.appendChild(li);
    });

    // Setup Add/Remove Button inside Drawer
    const variantId = cardElement.getAttribute('data-variant-id');
    drawerAddBtn.setAttribute('data-variant-id', variantId);
    
    // Sync Button style
    const isSelected = selectedItems.some(item => item.id === variantId);
    if (isSelected) {
      drawerAddBtn.textContent = 'REMOVE FROM CAPSULE';
      drawerAddBtn.style.backgroundColor = 'var(--color-gold)';
    } else {
      drawerAddBtn.textContent = 'ADD TO CAPSULE';
      drawerAddBtn.style.backgroundColor = 'var(--color-charcoal)';
    }

    // Click handler for drawer button
    drawerAddBtn.onclick = function() {
      toggleItemSelection(cardElement);
    };

    // Slide open drawer
    drawer.classList.add('is-open');
    drawerOverlay.classList.add('is-active');
  }

  // Close Quickview Drawer
  function closeQuickview() {
    drawer.classList.remove('is-open');
    drawerOverlay.classList.remove('is-active');
    // Pause video if playing
    const video = drawerMediaFrame.querySelector('video');
    if (video) video.pause();
  }

  drawerCloseBtn.addEventListener('click', closeQuickview);
  drawerOverlay.addEventListener('click', closeQuickview);

  // Cart Batch Submission
  footerCta.addEventListener('click', function() {
    if (selectedItems.length !== MAX_ITEMS) return;

    footerCta.disabled = true;
    footerCta.textContent = 'CREATING YOUR CAPSULE...';

    // Retrieve bundle product variant ID from container data attribute
    const builderContainer = document.getElementById('SeoulBuilder');
    const bundleVariantId = builderContainer ? builderContainer.getAttribute('data-bundle-variant-id') : '';

    if (!bundleVariantId) {
      alert('Error: Please select the Bundle Product in your Theme Customizer settings first.');
      footerCta.disabled = false;
      footerCta.textContent = 'CLAIM YOUR CAPSULE';
      return;
    }

    // Build the custom line item properties containing the selected earrings
    const properties = {};
    selectedItems.forEach((item, index) => {
      properties[`Pair ${index + 1}`] = item.title;
    });

    const cartItems = [{
      id: parseInt(bundleVariantId),
      quantity: 1,
      properties: properties
    }];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: cartItems
      })
    })
    .then(response => response.json())
    .then(data => {
      // Redirect directly to the Cart page where the bundle is listed at its flat ₹799 rate
      window.location.href = '/cart';
    })
    .catch(error => {
      console.error('Error adding bundle to cart:', error);
      alert('Something went wrong adding the capsule to the cart. Please try again.');
      footerCta.disabled = false;
      footerCta.textContent = 'CLAIM YOUR CAPSULE — ₹1,199';
    });
  });
});
